(function () {
  'use strict';

  let angular = window.angular;

  DataSourceRouter.$inject = ['$stateProvider'];

  angular.module('app').config(DataSourceRouter);

  function DataSourceRouter($stateProvider) {
    $stateProvider
      .state('member.dataSource', {
        url: '/data-source',
        redirectTo: 'member.dataSource.apiKey',
        template: '<ui-view></ui-view>',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Data Source',
        },
        resolve: {
          hasTool: [
            'customer',
            'AppUtils',
            function (customer, utils) {
              return true;
            },
          ],
        },
      })
      .state('member.dataSource.apiKey', {
        url: '/api-key/:apiKeyId',
        componentProvider: ['NativeAppIntegration', function (integration) {
          return integration.useNative() ? 'apiKeysEntry' : 'connectionApiKey';
        }],
        authenticated: true,
        params: {
          apiKeyId: {
            type: 'string',
            dynamic: true,
            squash: true,
          },
        },
        ncyBreadcrumb: {
          label: '{{"entities.apikey.modelNamePl" | translate}}',
        },
        resolve: {
          customerId: ['Manager', (Manager) => Manager.getCachedCurrent().customerId],
          apiKeys: [
            'Customer',
            'Manager',
            'AppUtils',
            'NativeAppIntegration',
            function (Customer, Manager, utils, integration) {
              if (integration.useNative()) return null;
              const user = Manager.getCachedCurrent();
              return Customer.apiKeys({ id: user.customerId })
                .$promise.then(function (keys) {
                  keys.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
                  let tree = [];
                  keys.forEach((key) => {
                    tree.push({
                      id: key.id,
                      text: key.name,
                      parent: '#',
                    });
                  });
                  return { tree: tree, keys: keys };
                })
                .catch((err) => {
                  throw utils.getHTTPError(err, {
                    redirectTo: 'member.home',
                    params: { customerId: user.customerId },
                  });
                });
            },
          ],
        },
      })

      .state('member.dataSource.device', {
        url: '/device/:deviceId',
        component: 'connectionDevice',
        authenticated: true,
        params: {
          deviceId: {
            type: 'string',
            dynamic: true,
            squash: true,
          },
        },
        ncyBreadcrumb: {
          label: '{{"entities.device.modelNamePl" | translate}}',
        },
        resolve: {
          dependencies: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/editors/jsoneditor.min.js',
                window.assetsPath + '/js/vendors/editors/jsondiffpatch.umd.js',
                window.assetsPath + '/js/vendors/editors/simplemde.min.js',
                window.assetsPath + `/css/editors-${style}.css`,
              ]);
            },
          ],
          assets: [
            'assetUtilsService',
            function (AssetUtils) {
              return AssetUtils.loadTree(true, ['id', 'name', 'assetId', 'projectId'], undefined);
            },
          ],
          devices: [
            'Customer',
            'Manager',
            'AppUtils',
            'assetUtilsService',
            function (Customer, Manager, utils, assetUtilsService) {
              const user = Manager.getCachedCurrent();
              let devices = [];
              let deviceMap = {};
              return Customer.devices({ id: user.customerId })
                .$promise.then(function (result) {
                  devices = result;
                  devices.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
                  devices.forEach((device) => {
                    device.status = assetUtilsService.getStatus(device);
                    deviceMap[device.id] = device;
                  });
                  let tree = [];
                  devices.forEach((device) => {
                    tree.push({
                      id: device.id,
                      text: device.name,
                      version: device.version,
                      parent: '#',
                      li_attr: {
                        'data-status': device.status,
                      },
                    });
                  });
                  return { tree: tree, devices: devices };
                })
                .catch((err) => {
                  throw utils.getHTTPError(err, {
                    redirectTo: 'member.home',
                    params: { customerId: user.customerId },
                  });
                });
            },
          ],
        },
      })
      .state('member.dataSource.telegramChat', {
        url: '/telegramChats/:telegramChatId',
        component: 'connectionTelegramChat',
        authenticated: true,
        params: {
          telegramChatId: {
            type: 'string',
            dynamic: true,
            squash: true,
          },
        },
        ncyBreadcrumb: {
          label: '{{"entities.telegramchat.modelNamePl" | translate}}',
        },
        resolve: {
          dependencies: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/editors/simplemde.min.js',
                window.assetsPath + `/css/editors-${style}.css`,
              ]);
            },
          ],
          telegramChats: [
            'Customer',
            'Manager',
            '$transition$',
            'AppUtils',
            'assetUtilsService',
            function (Customer, Manager, $transition$, utils, assetUtilsService) {
              const user = Manager.getCachedCurrent();
              return Customer.telegramChats({ id: user.customerId })
                .$promise.then(function (telegramChats) {
                  telegramChats.sort((a, b) =>
                    a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
                  );
                  let tree = [];
                  telegramChats.forEach((telegramChat) => {
                    tree.push({
                      id: telegramChat.id,
                      text: telegramChat.name,
                      parent: '#',
                    });
                  });
                  return { tree: tree, telegramChats: telegramChats };
                })
                .catch((err) => {
                  throw utils.getHTTPError(err, {
                    redirectTo: 'member.home',
                    params: { customerId: user.customerId },
                  });
                });
            },
          ],
        },
      })
      .state('member.dataSource.emergencyContact', {
        url: '/emergencyContacts/:emergencyContactId',
        component: 'connectionEmergencyContact',
        authenticated: true,
        params: {
          emergencyContactId: {
            type: 'string',
            dynamic: true,
            squash: true,
          },
        },
        ncyBreadcrumb: {
          label: '{{"entities.emergencycontact.modelNamePl" | translate}}',
        },
        resolve: {
          dependencies: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/intlTelInput/intlTelInput.css',
                window.assetsPath + '/js/vendors/intlTelInput/intlTelInput-jquery.min.js',
                window.assetsPath + '/js/vendors/intlTelInput/utils.min.js',
                window.assetsPath + '/js/vendors/intlTelInput/ng-intl-tel-input.min.js',
                window.assetsPath + '/js/vendors/editors/simplemde.min.js',
                window.assetsPath + `/css/editors-${style}.css`,
              ]);
            },
          ],
          emergencyContacts: [
            'Customer',
            '$transition$',
            'AppUtils',
            function (Customer, $transition$, utils) {
              let params = $transition$.params();

              return Customer.emergencyContacts({ id: params.customerId })
                .$promise.then(function (emergencyContacts) {
                  emergencyContacts.sort((a, b) =>
                    a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
                  );
                  let tree = [];
                  emergencyContacts.forEach((current) => {
                    tree.push({
                      id: current.id,
                      text: current.name,
                      parent: '#',
                    });
                  });
                  return { tree: tree, emergencyContacts: emergencyContacts };
                })
                .catch((err) => {
                  throw utils.getHTTPError(err, {
                    redirectTo: 'member.home',
                    params: { customerId: params.customerId },
                  });
                });
            },
          ],
        },
      });
  }
})();
